import React  from 'react';
import LoginComp from '../components/Login/loginComp';
function Login() {
  return (
    <>
    <LoginComp />
    {/* <ForgotPassword /> */}
    </>
  );
}

export default Login;
